export default {
  PopupTitle: 'Tham số báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  Chapter: 'Chương',
  BudgetKindItem: 'Khoản',
  BudgetItemCode: 'Mục',
  Cancel: 'Hủy',
  PrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  DisplayAcumMovement: 'Hiển thị cột lũy kế',
  GetDataSpendRegular: 'Lấy số liệu chi thường xuyên',
  GetDataXDCB: 'Lấy số liệu XDCB',
  Source: 'Nguồn',
};
